import { useState, useEffect } from "react"
import { ethers } from "ethers"

const RandomHenry = require('./artifacts/contracts/RandomHenry.sol/RandomHenry.json');
const RHaddress = "0x2D3492ea8F7D02E8A409CC42839A24703bfDA7c1";
const MaxTokenPerWallet = 10;
const globalSupply = 1000;

function Minter(){
    const [error, setError] = useState('')
    const [data, setData] = useState({})
    var [userData, setUserData] = useState({})
    var [AmountNFTtoMint, setAmountNFTtoMint] = useState(1)
    var [LocalDataArray, setLocalDataArray] = useState([])
    var [WhitelistedWallets, setWhitelistedWallets] = useState([])
    var [FreeMintWallets, setFreeMintWallets] = useState([])
    var [HoldersWallets, setHoldersWallets] = useState([])
    var [Password, setPassword] = useState("")
    var [HenrysInWallet, setHenrysInWallet] = useState([])
    var [saleStatus, setSaleStatus] = useState(0)
    var [transaction, setTransaction] = useState(0)

    useEffect(() => {
        fetchData();
    });

    async function fetchData(){  
        if (window.ethereum){    
            var object = {};
            var userObject = {};

            let account = window.ethereum.selectedAddress;
            window.account = account;

            if (account !== null) {
                
                const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
                const signer = provider.getSigner();
                const walletAddress = signer.getAddress();

                let network = await provider.getNetwork();  

                const contract = new ethers.Contract(RHaddress, RandomHenry.abi, provider);

                if (String(network.name) === "matic"){
                    
                    const WL = await contract.returnWhitelist();
                    setWhitelistedWallets(WL);

                    const FM = await contract.returnFreeMint();
                    setFreeMintWallets(FM);

                    const Holders = await contract.returnHolders();
                    setHoldersWallets(Holders);

                    const newSaleStatus = await contract.returnSaleStatus();
                    setSaleStatus(newSaleStatus);

                    const publicCost = await contract.publicCost();
                    const whitelistCost = await contract.whitelistCost();
                    const totalSupply = await contract.totalSupply();
                    const NFTminted = await contract.balanceOf(walletAddress);
                    object = {"publicCost": String(publicCost), "whitelistCost": String(whitelistCost), "totalSupply": String(totalSupply), "NFTminted": String(NFTminted), "network": String(network.name), "userWallet": String(account)};
                }
                else{
                    object = {"publicCost": "0", "whitelistCost": "0", "totalSupply": "0", "NFTminted": "0", "network": String(network.name), "userWallet": String(account)};
                }
                setData(object);  

                userObject = {"status": "visitor", "whitelistSpot": "0", "FreeMint": "0"};
                
                if (account === "0x8036f606de4C83B23B5c6B16472116EFF15859a9".toLowerCase()){
                    userObject.status = "Admin";

                    //const P = await contract.returnPasswords();
                    //setAllPasswords(String(P));

                } else if (HoldersWallets.includes(data.userWallet)) {
                    userObject.status = "Henry Owner";
                }
                else{
                    userObject.status = "Visitor";
                }
                
                if (data.userWallet !== ""){
                    userObject.whitelistSpot = setAmountInArray(data.userWallet, WhitelistedWallets);
                    
                    if (AmountNFTtoMint > userObject.whitelistSpot && userObject.whitelistSpot > 0){
                        setAmountNFTtoMint(userObject.whitelistSpot);
                    }

                    userObject.FreeMint = setAmountInArray(data.userWallet, FreeMintWallets);

                    if (AmountNFTtoMint > userObject.FreeMint && userObject.FreeMint > 0){
                        setAmountNFTtoMint(userObject.FreeMint);
                    }
                }

                setUserData(userObject);

                if (userObject.status === "Admin" || userObject.status === "Henry Owner"){
                    const HenrysInWallet = await contract.walletOfOwner(walletAddress);
                    if (HenrysInWallet.length > 0) {
                        setHenrysInWallet(arrayObjectToString(HenrysInWallet));
                        const Password = await contract.returnOnePassword(HenrysInWallet[0]-1);
                        setPassword(Password);
                    }
                }

            } else{
                object = {"publicCost": "0", "whitelistCost": "0", "totalSupply": "0", "NFTminted": "0", "network": "", "userWallet": ""};
                setData(object);    
            }       
        }
    }

    function setAmountInArray(value, array){
        var amount = 0;

        for (var i = 0; i < array.length; i++){
            if (array[i] === value){
                amount ++;
            }
        }
        return(amount)
    }

    function arrayObjectToString(oldArray){
        var newArray = [];
        for (var i = 0; i < oldArray.length; i++){
            newArray.push(String(oldArray[i]));
        }
        return (newArray);
    }

    async function mint(){
        if(window.ethereum){
            if (transaction === 0 && data.userWallet !== ""){
                setTransaction(1);
                let accounts = await window.ethereum.request({method: 'eth_requestAccounts'});

                if (data.network === "matic"){
                    const provider = new ethers.providers.Web3Provider(window.ethereum, "matic");

                    //const provider = new ethers.providers.JsonRpcProvider("https://polygon-mainnet.g.alchemy.com/v2/Y0gWxAy_9mYLfbsmz2lxQ3GAeg2Tbigd", "any");
                    const signer = provider.getSigner(data.userWallet);
                    const contract = new ethers.Contract(RHaddress, RandomHenry.abi, signer);
                    const funds = await provider.getBalance(data.userWallet);
                    
                    try{                        
                        var cost;
                        if (userData.FreeMint > 0 ){
                            cost = 0;
                        }
                        else if(userData.whitelistSpot > 0){
                            cost = data.whitelistCost;
                        }
                        else{
                            cost = data.publicCost;
                        }
        
                        let overrides = {
                            from: accounts[0],
                            value: String(cost * AmountNFTtoMint),
                            gasPrice: await provider.getGasPrice()
                        };
                        
                        const token = randomToken(1000);
                        setError("");

                        const transaction = await contract.mint(accounts[0], AmountNFTtoMint, token, data.userWallet, overrides);
                        await transaction.wait();

                        fetchData();
                        setTransaction(0);
                    }
                    catch(err){
                        if (err.message === "Internal JSON-RPC error."){
                            if (funds / 10**18 < cost){
                                setError(String("Not enough Matic in your wallet."));
                            } else {
                                setError("Internal JSON-RPC error.");
                            }
                        } else {
                            if (String(err.message).length > 50) {
                                setError(String(err.message).substring(0, 50) + "...");
                            } else {
                                setError(String(err.message));
                            }
                        }
                        setTransaction(0);
                    }
                }  
                else {
                    setTransaction(0);
                } 
            }
            
        }
    }

    function randomToken(length){
        let tokensArray = [];
        for (var i = 1; i < length; i++){
            tokensArray.push(randomIntFromInterval(1, globalSupply));
        }
        return(tokensArray);
    }

    function randomIntFromInterval(min, max) { // min and max included 
        return Math.floor(Math.random() * (max - min + 1) + min)
      }

    async function changePublicCost(){
        if(window.ethereum){
            
            const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
            const signer = provider.getSigner();
            const contract = new ethers.Contract(RHaddress, RandomHenry.abi, signer);

            try{
                const price = document.getElementById("publicCost").value * 10**18;
                const transaction = await contract.setPublicCost(String(price));
                await transaction.wait();
            }
            catch(err){
                setError(err.message);
            }
        }
    }

    async function changeWLCost(){
        if(window.ethereum){
            
            const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
            const signer = provider.getSigner();
            //let accounts = await provider.listAccounts();
            const contract = new ethers.Contract(RHaddress, RandomHenry.abi, signer);

            try{
                //const randomValue = Math.floor(Math.random() * (10 * 100 - 1 * 100) + 10 * 100) / (1 * 100);
                const price = document.getElementById("WlCost").value * 10**18;
                const transaction = await contract.setWLCost(String(price));
                await transaction.wait();
            }
            catch(err){
                setError(err.message);
            }
        }
    }

    async function UpdateWL(){
        if(window.ethereum){
            
            var checkbox = document.getElementById("checkbox");

            const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
            const signer = provider.getSigner();
            const contract = new ethers.Contract(RHaddress, RandomHenry.abi, signer);

            var Whitelist = [];

            if (checkbox.checked){
                Whitelist = LocalDataArray
            } else{
                Whitelist = WhitelistedWallets.concat(LocalDataArray)
            }
            
            try{
                const transaction = await contract.setWhitelist(Whitelist);
                await transaction.wait();
            }
            catch(err){
                setError(err.message);
            }
        }
    }

    async function UpdateFreeMints(){
        if(window.ethereum){
            
            var checkbox = document.getElementById("checkbox");

            const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
            const signer = provider.getSigner();
            const contract = new ethers.Contract(RHaddress, RandomHenry.abi, signer);
            
            var Freemints = [];

            if (checkbox.checked){
                Freemints = LocalDataArray
            } else{
                Freemints = FreeMintWallets.concat(LocalDataArray)
            }

            try{
                const transaction = await contract.setFreeMint(Freemints);
                await transaction.wait();
            }
            catch(err){
                setError(err.message);
            }
        }
    }

    async function UpdatePasswords(){
        if(window.ethereum){
            const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
            const signer = provider.getSigner();
            const contract = new ethers.Contract(RHaddress, RandomHenry.abi, signer);

            try{
                const transaction = await contract.setPasswords(LocalDataArray);
                await transaction.wait();
            }
            catch(err){
                setError(err.message);
            }
        }
    }

    async function withdraw(){
        if(window.ethereum){
            const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
            const signer = provider.getSigner();
            const contract = new ethers.Contract(RHaddress, RandomHenry.abi, signer);

            try{
                const transaction = await contract.withdraw();
                await transaction.wait();
            }
            catch(err){
                setError(err.message);
            }
        }
    }

    function IncreaseAmount() {
        if (userData.FreeMint === 0 || AmountNFTtoMint < userData.FreeMint) {
            if (userData.whitelistSpot === 0 || AmountNFTtoMint < userData.whitelistSpot) {
                if (AmountNFTtoMint < MaxTokenPerWallet - data.NFTminted && AmountNFTtoMint < globalSupply - data.totalSupply){
                    setAmountNFTtoMint(AmountNFTtoMint + 1);
                }
            }
        }
      }
    
    function DecreaseAmount() {
        if (AmountNFTtoMint > 1){
            setAmountNFTtoMint(AmountNFTtoMint - 1);
        }
    }

    function fileUpload(){
        var file = document.getElementById("upload").files[0];
        
        let reader = new FileReader();
        reader.readAsText(file);

        reader.onload = function() {
            //document.getElementById('fileContents').value = reader.result; 
            const Array = JSON.parse(reader.result);
            //const wallet = object[5];
            
            var fileData = [];
            for (var i = 0; i < Array.length && i < 1000; i++){

                if (typeof Array[i] === "string"){
                    fileData.push(Array[i].toLowerCase());
                }
                else {
                    fileData.push(Array[i]["wallet"].toLowerCase());
                }
            }
            setLocalDataArray(fileData);
        };
    }

    async function Reveal(){

        const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
        const signer = provider.getSigner();
        const contract = new ethers.Contract(RHaddress, RandomHenry.abi, signer);

        var button = document.getElementById("Reveal");
        
        if (button.innerText === "Reveal"){
            const transaction = await contract.setBaseURI("ipfs://Qmd6kRzPJZ7ynLiWHV6c3K5BELraDjBpZ7L6PkUbE9jsfT/");
            await transaction.wait();
            button.innerText = "Hide";
        }
        else{
            const transaction = await contract.setBaseURI("ipfs://QmYbunB3arGuVNDvnyjmkuY7YQWyPd3tUaXvVn2Y7DoyF3/");
            await transaction.wait();
            button.innerText = "Reveal";
        }
    }

    async function SaleStatus(){

        const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
        const signer = provider.getSigner();
        const contract = new ethers.Contract(RHaddress, RandomHenry.abi, signer);

        var button = document.getElementById("SaleStatus");

        if (String(saleStatus) === "0"){
            const transaction = await contract.setSaleStatus(1);
            await transaction.wait();
            button.innerText = "Start Public Sale";
        }
        else if (String(saleStatus) === "1"){
            const transaction = await contract.setSaleStatus(2);
            await transaction.wait();
            button.innerText = "Stop Public Sale";
        }
        else{
            const transaction = await contract.setSaleStatus(0);
            await transaction.wait();
            button.innerText = "Start Presale";
        }
    }
    
    if (data.userWallet !== "") {
        if (data.network === "matic"){
            if (userData.status === "Admin"){
                return (
                    <div className="Minter">        
                        <div className="Mint">
                            <p id="totalSupply">TOTAL MINTED: {data.totalSupply} / 1000</p>
                            <div className="divMint">
                                {saleStatus > 0 ? <p>{saleStatus > 1 || (userData.FreeMint > 0 || userData.whitelistSpot > 0) ? <button id="btnMint" onClick={mint}>MINT LIVE</button> : <button id="btnBeforeMint">MINT LIVE</button>}</p> : <button id="btnBeforeMint">MINT LIVE</button>}
                            </div>

                            <div>{saleStatus > 0 ? <div>{saleStatus > 1 || ((userData.FreeMint > 0 || userData.whitelistSpot > 0)) ? <p id="warning">{error}</p> : <p id="warning">You don't have access to the presale.</p>}</div> : <p id="warning">Mint has ended!</p>}</div>

                            <div className="Counter">
                                <button className="btnAmount" onClick={DecreaseAmount}>-</button>
                                <p id="Amount">{AmountNFTtoMint}</p>
                                <button className="btnAmount" onClick={IncreaseAmount}>+</button>  
                            </div>
                            <div>{userData.FreeMint > 0
                                ?<p>Free Henry!</p>
                                : userData.whitelistSpot > 0 ? <p>Cost: {Math.round(data.whitelistCost / 10**18 * AmountNFTtoMint * 100) / 100} MATIC</p>
                                : <p>Cost: {Math.round(data.publicCost / 10**18 * AmountNFTtoMint * 100) / 100} MATIC</p>
                            }
                            <p className="Small"> {userData.FreeMint > 0 ? <p className="Small">{userData.FreeMint}x Free mint{userData.FreeMint > 1 ? "s" : ""} available</p> : ""} </p>
                            <p className="Small"> {userData.whitelistSpot > 0 ? <p className="Small">{userData.whitelistSpot}x Whitelist spot{userData.whitelistSpot > 1 ? "s" : ""} available</p> : ""} </p>
                            </div>
                        </div>
                        
                        <div className="Wallet"> 
                            <p className="SectionTitle">YOUR WALLET</p>
                            <p className="Medium">Status: {userData.status}</p>
                            <p id="HenryCode"> {Password}</p>
                            {Password !== "" ? <p className="VerySmall">Use this code in the #Verified Roles channel on Discord to get the Henry Owner role.</p> : <p></p>}
                            <hr className="hr1"></hr>
                            <p className="Medium">You hold {data.NFTminted} Henry{data.NFTminted > 1 ? "s" : ""} </p>
                            {HenrysInWallet.map(Henry => ( 
                                <div key={Henry} className="HenrysList">{HenrysInWallet.indexOf(Henry) <= 1 ? <p className="Medium">Henry #{Henry}</p> : HenrysInWallet.indexOf(Henry) === 2 ? <p className="VerySmall">And {HenrysInWallet.length - 2} others...</p> : <p className="VerySmall"></p>}</div>
                            ))}
                        </div>
    
                        <div className="AdminPannel"> 
                            <p className="SectionTitle">ADMIN</p>
                            <button id="withdraw" onClick={withdraw}>Withdraw</button>
                            <button onClick={Reveal} id="Reveal">Reveal</button>
                            <button onClick={SaleStatus} id="SaleStatus">{String(saleStatus) === "0" ? "Start Presale" : String(saleStatus) === "1" ? "Start Public Sale" : "Stop Public Sale"}</button><br/><br/>
            
                            <input type="number" placeholder="Enter a price (MATIC)" id="publicCost"/>
                            <button onClick={changePublicCost}>Set public COST</button><br/>
                            <input type="number" placeholder="Enter a price (MATIC)" id="WlCost"/>
                            <button onClick={changeWLCost}>Set WL COST</button><br/><br/>
    
                            <input type="file" id="upload" accept="application/json,.py" onChange={fileUpload}></input><br/><br/>
                            Replace content <input type="checkbox" id="checkbox"></input>

                            <button onClick={UpdateWL}>Whitelist</button>
                            <button onClick={UpdateFreeMints}>Free mints</button>
                            <button onClick={UpdatePasswords}>Passwords</button>
                            <p> {WhitelistedWallets.length} wallets whitelisted | {FreeMintWallets.length} wallets Free mint | {HoldersWallets.length} holder{HoldersWallets.length > 1 ? "s" : ""}</p>
                            <p>{WhitelistedWallets}</p>
                            <p>{FreeMintWallets}</p>
                        </div>
                    </div>
                );
            } else if (userData.status === "Henry Owner"){
                return (
                    <div className="Minter">
                        <div className="Mint">
                            <p id="totalSupply">TOTAL MINTED: {data.totalSupply} / 1000</p>

                            <div className="divMint">
                                {saleStatus > 0 ? <p>{saleStatus > 1 || ((userData.FreeMint > 0 || userData.whitelistSpot > 0)) ? <button id="btnMint" onClick={mint}>MINT LIVE</button> : <button id="btnBeforeMint">MINT LIVE</button>}</p> : <button id="btnBeforeMint">MINT LIVE</button>}
                            </div>

                            <div>{saleStatus > 0 ? <div>{saleStatus > 1 || ((userData.FreeMint > 0 || userData.whitelistSpot > 0)) ? <p id="warning">{error}</p> : <p id="warning">You don't have access to the presale.</p>}</div> : <p id="warning">Mint has ended!</p>}</div>
                            
                            <div className="Counter">
                                <button className="btnAmount" onClick={DecreaseAmount}>-</button>
                                <p id="Amount">{AmountNFTtoMint}</p>
                                <button className="btnAmount" onClick={IncreaseAmount}>+</button>  
                            </div>
                            <div>{userData.FreeMint > 0
                                ?<p>Free Henry!</p>
                                : userData.whitelistSpot > 0 ? <p>Cost: {Math.round(data.whitelistCost / 10**18 * AmountNFTtoMint * 100) / 100} MATIC</p>
                                : <p>Cost: {Math.round(data.publicCost / 10**18 * AmountNFTtoMint * 100) / 100} MATIC</p>
                            }
                            <p className="Small"> {userData.FreeMint > 0 ? <p className="Small">{userData.FreeMint}x Free mint{userData.FreeMint > 1 ? "s" : ""} available</p> : ""} </p>
                            <p className="Small"> {userData.whitelistSpot > 0 ? <p className="Small">{userData.whitelistSpot}x Whitelist spot{userData.whitelistSpot > 1 ? "s" : ""} available</p> : ""} </p>
                            </div>
                        </div>
                        
                        <div className="Wallet"> 
                            <p className="SectionTitle">YOUR WALLET</p>
                            <p className="Medium">Status: {userData.status}</p>
                            <p id="HenryCode"> {Password}</p>
                            {Password !== "" ? <p className="VerySmall">Use this code in the #Verified Roles channel on Discord to get the Henry Owner role.</p> : <p></p>}
                            <hr className="hr1"></hr>
                            <p className="Medium">You hold {data.NFTminted} Henry{data.NFTminted > 1 ? "s" : ""} </p>
                            {HenrysInWallet.map(Henry => ( 
                                <div key={Henry} className="HenrysList">{HenrysInWallet.indexOf(Henry) <= 1 ? <p className="Medium">Henry #{Henry}</p> : HenrysInWallet.indexOf(Henry) === 2 ? <p className="VerySmall">And {HenrysInWallet.length - 2} others...</p> : <p className="VerySmall"></p>}</div>
                            ))}
                        </div>
                    </div>
                );
            } else {
                return (
                    <div className="Minter">
                        <div className="Mint">
                            <p id="totalSupply">TOTAL MINTED: {data.totalSupply} / 1000</p>
                            
                            <div className="divMint">
                                {saleStatus > 0 ? <div>{saleStatus > 1 || ((userData.FreeMint > 0 || userData.whitelistSpot > 0)) ? <button id="btnMint" onClick={mint}>MINT LIVE</button> : <button id="btnBeforeMint">MINT LIVE</button>}</div> : <button id="btnBeforeMint">MINT LIVE</button>}
                            </div>

                            <div>{saleStatus > 0 ? <div>{saleStatus > 1 || ((userData.FreeMint > 0 || userData.whitelistSpot > 0)) ? <p id="warning">{error}</p> : <p id="warning">You don't have access to the presale.</p>}</div> : <p id="warning">Mint has ended!</p>}</div>

                            <div className="Counter">
                                <button className="btnAmount" onClick={DecreaseAmount}>-</button>
                                <p id="Amount">{AmountNFTtoMint}</p>
                                <button className="btnAmount" onClick={IncreaseAmount}>+</button>  
                            </div>
                            <div>{userData.FreeMint > 0
                                ?<p>Free Henry!</p>
                                : userData.whitelistSpot > 0 ? <p>Cost: {Math.round(data.whitelistCost / 10**18 * AmountNFTtoMint * 100) / 100} MATIC</p>
                                : <p>Cost: {Math.round(data.publicCost / 10**18 * AmountNFTtoMint * 100) / 100} MATIC</p>
                            }
                            <p className="Small"> {userData.FreeMint > 0 ? <p className="Small">{userData.FreeMint}x Free mint{userData.FreeMint > 1 ? "s" : ""} available</p> : ""} </p>
                            <p className="Small"> {userData.whitelistSpot > 0 ? <p className="Small">{userData.whitelistSpot}x Whitelist spot{userData.whitelistSpot > 1 ? "s" : ""} available</p> : ""} </p>
                            </div>
                        </div>
                        
                        <div className="Wallet"> 
                            <p className="SectionTitle">YOUR WALLET</p>
                            <p className="Medium">Status: {userData.status}</p>
                            <p id="HenryCode"> {Password}</p>
                            {Password !== "" ? <p className="VerySmall">Use this code in the #Verified Roles channel on Discord to get the Henry Owner role.</p> : <p></p>}
                            <hr className="hr1"></hr>
                            <p className="Medium">You hold {data.NFTminted} Henry{data.NFTminted > 1 ? "s" : ""} </p>
                            {HenrysInWallet.map(Henry => ( 
                                <div key={Henry} className="HenrysList">{HenrysInWallet.indexOf(Henry) <= 1 ? <p className="Medium">Henry #{Henry}</p> : HenrysInWallet.indexOf(Henry) === 2 ? <p className="VerySmall">And {HenrysInWallet.length - 2} others...</p> : <p className="VerySmall"></p>}</div>
                            ))}
                        </div>
                    </div>
                );
            }
        } else {
            return (
                <div className="Minter">
                    <div className="Mint">
                        <p id="message">Please switch to Polygon network ⚠</p>
    
                        <p id="totalSupply">TOTAL MINTED: {data.totalSupply} / 1000</p>
                        <div className="divMint">
                            <button id="btnBeforeMint">MINT LIVE</button>
                        </div>
                        <div className="Counter">
                            <button className="btnAmount" onClick={DecreaseAmount}>-</button>
                            <p id="Amount">{AmountNFTtoMint}</p>
                            <button className="btnAmount" onClick={IncreaseAmount}>+</button>  
                        </div>
                        <p className = "cost">Cost: {Math.round(30 * AmountNFTtoMint * 100) / 100} MATIC</p>
                    </div>
                    
                </div>
            ); 
        }
    } else {
        return (
            <div className="Minter">
                <div className="Mint">
                    <p id="warning">Connect your metamask wallet first ⚠</p>

                    <p id="totalSupply">TOTAL MINTED: {data.totalSupply} / 1000</p>
                    <div className="divMint">
                        <button id="btnBeforeMint">MINT LIVE</button>
                    </div>
                    <div className="Counter">
                        <button className="btnAmount" onClick={DecreaseAmount}>-</button>
                        <p id="Amount">{AmountNFTtoMint}</p>
                        <button className="btnAmount" onClick={IncreaseAmount}>+</button>  
                    </div>
                    <p className = "cost">Cost: {Math.round(30 * AmountNFTtoMint * 100) / 100} MATIC</p>
                </div>
                
            </div>
        ); 
    }  
}

export default Minter;
